import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
} from "@mui/material";
import Link from "next/link";
import { primary } from "../../../constants/theme";

const CustomPopularVehiclesTable = styled(Box)(({ theme }) => ({
  width: "84%",
  margin: "40px auto",
  "&.inline": {
    width: "100%",
    margin: "0",
  },
  ".content-heading2": {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "20px",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: "0 12px",
    "&.inline": {
      padding: "0",
    },
    ".content-heading2": {
      fontSize: "24px",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "0 12px",
    "&.inline": {
      padding: "0",
    },
    ".content-heading2": {
      fontSize: "20px",
    },
  },
}));

const PopularVehiclesTable = ({ heading, vehiclesData, inline = false }) => {
  return (
    <CustomPopularVehiclesTable className={inline ? "inline" : ""}>
      <Typography variant="h2" className="content-heading2">
        {heading}
      </Typography>

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
        }}
      >
        <Table
          sx={{ 
            minWidth: { xs: 300, sm: 650 },
            "& .MuiTableCell-root": {
              borderRight: "1px solid #e0e0e0",
              "&:last-child": {
                borderRight: "none",
              }
            }
          }}
          aria-label="popular vehicles price table"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "14px", md: "16px" },
                  color: "#000",
                  padding: { xs: "12px 8px", md: "16px" },
                }}
              >
                Electric Commercial Vehicles in India
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "14px", md: "16px" },
                  color: "#000",
                  padding: { xs: "12px 8px", md: "16px" },
                }}
              >
                Price Range
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vehiclesData.map((vehicle) => (
              <TableRow
                key={vehicle.name}
                sx={{
                  "&:last-child td, &:last-child th": { borderBottom: 0 },
                  "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontSize: { xs: "12px", md: "16px" },
                    color: "#000",
                    fontWeight: 400,
                    padding: { xs: "10px 8px", md: "12px 16px" },
                  }}
                >
                  {vehicle.link ? (
                    <Link
                      href={vehicle.link}
                      style={{
                        color: "#000",
                        textDecoration: "underline",
                        fontWeight: 400,
                      }}
                    >
                      {vehicle.name}
                    </Link>
                  ) : (
                    vehicle.name
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: { xs: "12px", md: "16px" },
                    color: "#000",
                    fontWeight: 400,
                    padding: { xs: "10px 8px", md: "12px 16px" },
                  }}
                >
                  {vehicle.priceRange}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CustomPopularVehiclesTable>
  );
};

export default PopularVehiclesTable;

